// extracted by mini-css-extract-plugin
export var errorsContainer = "_u6-1";
export var link = "_u6-0";